export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => () => rootGetters['layoutModule/header'],
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    background: (state, getters) => element => getters.elements(element).background,
    content: (state, getters) => element => getters.elements(element).content,
    properties: (state, getters) => element => getters.elements(element).properties,
    assets: (state, getters) => element => getters.elements(element).assets,
  },
  actions: {
    addToArray({commit}, payload) {
      payload = {...payload, module: 'headerModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'headerModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
  }
}